import { useQuery } from "@tanstack/react-query";
import { GetPlatformFeaturesDocument } from "@/common/artemis-sdk/graphql";
import { useGqlClient } from "../use-gql-client";

/**
 * The opt-in integrations this installation has switched on (docs/feature-flags.md). Fixed for
 * the API's lifetime, so it's fetched once per session.
 */
export function usePlatformFeatures() {
	const gqlFetch = useGqlClient();
	return useQuery({
		queryKey: ["platformFeatures"],
		queryFn: async () =>
			(await gqlFetch(GetPlatformFeaturesDocument)).platformFeatures,
		staleTime: Number.POSITIVE_INFINITY,
	});
}
